var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsdActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5BC6\u7801_current@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186FF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186FF0",
    stopOpacity: 0.75,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u63A7\\u4EF6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BC6\\u7801"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C12.9181734,3 13.6711923,3.70711027 13.7441988,4.60647279 L13.75,4.75 L13.75,7 L15.5,7 C16.0522847,7 16.5,7.44771525 16.5,8 L16.5,15 C16.5,15.5522847 16.0522847,16 15.5,16 L4.5,16 C3.94771525,16 3.5,15.5522847 3.5,15 L3.5,8 C3.5,7.44771525 3.94771525,7 4.5,7 L6.25,7 L6.25,4.75 C6.25,3.8318266 6.95711027,3.07880766 7.85647279,3.0058012 L8,3 L12,3 Z M14.5,8.5 L5.5,8.5 C5.25454011,8.5 5.05039163,8.67687516 5.00805567,8.91012437 L5,9 L5,14 C5,14.2454599 5.17687516,14.4496084 5.41012437,14.4919443 L5.5,14.5 L14.5,14.5 C14.7454599,14.5 14.9496084,14.3231248 14.9919443,14.0898756 L15,14 L15,9 C15,8.72385763 14.7761424,8.5 14.5,8.5 Z M10.5,10.25 C10.6380712,10.25 10.75,10.3619288 10.75,10.5 L10.75,12.5 C10.75,12.6380712 10.6380712,12.75 10.5,12.75 L9.5,12.75 C9.36192881,12.75 9.25,12.6380712 9.25,12.5 L9.25,10.5 C9.25,10.3619288 9.36192881,10.25 9.5,10.25 L10.5,10.25 Z M12,4.5 L8,4.5 C7.88165327,4.5 7.78251318,4.58223341 7.75660268,4.69267729 L7.75,4.75 L7.75,7 L12.25,7 L12.25,4.75 C12.25,4.65532261 12.1973706,4.57293748 12.1197716,4.53050435 L12.0573227,4.50660268 L12,4.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsdActive);
export default __webpack_public_path__ + "static/media/psd-active.7cc927d020ea1d62a8fb0ceab8850b7d.svg";
export { ForwardRef as ReactComponent };